import { PriceRange } from 'src/search/types/PriceRange';

export const PRICE_RANGE_MAP: Record<string, PriceRange> = {
  AED: { max: 7000, min: 1 },
  ARS: { max: 360000, min: 1 },
  AUD: { max: 2000, min: 1 },
  BRL: { max: 10000, min: 1 },
  CAD: { max: 2000, min: 1 },
  CHF: { max: 2000, min: 1 },
  CNY: { max: 13000, min: 1 },
  CRC: { max: 1000000, min: 1 },
  DKK: { max: 14000, min: 1 },
  EUR: { max: 2000, min: 1 },
  GBP: { max: 2000, min: 1 },
  HKD: { max: 15000, min: 1 },
  IDR: { max: 30000000, min: 1 },
  ILS: { max: 7000, min: 1 },
  INR: { max: 160000, min: 1 },
  ISK: { max: 280000, min: 1 },
  JPY: { max: 260000, min: 1 },
  KES: { max: 240000, min: 1 },
  KRW: { max: 2500000, min: 1 },
  MAD: { max: 20000, min: 1 },
  MXN: { max: 30000, min: 1 },
  MYR: { max: 8000, min: 1 },
  NOK: { max: 20000, min: 1 },
  NZD: { max: 3000, min: 1 },
  PEN: { max: 7000, min: 1 },
  PHP: { max: 100000, min: 1 },
  PLN: { max: 8000, min: 1 },
  RUB: { max: 130000, min: 1 },
  SEK: { max: 20000, min: 1 },
  SGD: { max: 2000, min: 1 },
  THB: { max: 60000, min: 1 },
  TRY: { max: 30000, min: 1 },
  TWD: { max: 60000, min: 1 },
  USD: { max: 2000, min: 1 },
  VND: { max: 47000000, min: 1 },
  ZAR: { max: 30000, min: 1 },
};

export const DEFAULT_SLUG = 'boat-rental';

export const REVIEWS_ANCHOR = 'reviews';
